module.exports = function getResource(label, vars = []) {
    let resources = {
        welcomeTo: 'Welcome to',
        beautyInsider: 'Beauty Insider',
        joinNow: 'Join Now'
    };

    return resources[label];
};
